// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_bE","container":"_bF","panel":"_bG","navigation":"_bH","icon":"_bI","title":"_bJ","select":"_bK","new_question_btn":"_bL"};